import React from 'react';
import clsx from 'clsx';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import type { ExportCardProps } from './exportCard.types';

/** Card padrão da página de exportações: cabeçalho, filtros opcionais e botão. */
export const ExportCard: React.FC<ExportCardProps> = ({
    title,
    description,
    icon: Icon,
    children,
    progressLabel,
    isExporting,
    disabled = false,
    onExport,
}) => {
    const isDisabled = isExporting || disabled;

    return (
        <div className="flex flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow">
            <div className="flex-1 p-5">
                <div className="flex items-center">
                    <div className="flex-shrink-0">
                        <Icon className="h-6 w-6 text-gray-400" aria-hidden="true" />
                    </div>
                    <div className="ml-5 w-0 flex-1">
                        <dl>
                            <dt className="truncate text-sm font-medium text-gray-500">{title}</dt>
                            <dd>
                                <div className="mt-1 text-sm text-gray-900">{description}</div>
                            </dd>
                        </dl>
                    </div>
                </div>

                {children && <div className="mt-4">{children}</div>}
            </div>

            <div className="bg-gray-50 px-5 py-3">
                <button
                    type="button"
                    onClick={onExport}
                    disabled={isDisabled}
                    className={clsx(
                        'flex w-full items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-white shadow-sm',
                        isDisabled
                            ? 'cursor-not-allowed bg-indigo-400'
                            : 'bg-indigo-600 hover:bg-indigo-700'
                    )}
                >
                    {isExporting ? (
                        <>
                            <svg
                                className="-ml-1 mr-3 h-5 w-5 animate-spin text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                />
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                />
                            </svg>
                            {progressLabel || 'Gerando...'}
                        </>
                    ) : (
                        <>
                            <ArrowDownTrayIcon className="mr-2 h-5 w-5" />
                            Exportar XLS
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export default ExportCard;
